<template>
    <div class="relative">
        <div :class="containerClasses">
            <div v-if="loading" class="animate-pulse flex gap-x-2">
                <div
                    v-for="i in 2"
                    :class="`h-6 w-12 rounded-tag border border-current`"
                />
            </div>
            <TypeTag
                v-else
                v-for="(type, index) in visibleTags"
                classes="tag"
                :key="index"
                :type="type"
            />
            <TextTooltip
                v-if="!loading && visibleTags.length != types.length"
                :text="hiddenTypesTooltipText"
                :delay="100"
            >
                <Tag
                    :text="`+${types.length - visibleTags.length}`"
                    class="cursor-help"
                />
            </TextTooltip>
        </div>

        <div
            ref="measureContainer"
            :class="[containerClasses, 'absolute w-full h-0 overflow-hidden']"
        >
            <TypeTag
                v-for="(type, index) in types"
                :key="index"
                :type="type"
                classes="tag"
            />
            <Tag ref="extraTag" :text="'+' + types.length" />>
        </div>
    </div>
</template>

<script>
import Tag from '@/Components/Elements/Tags/Tag.vue'
import TypeTag from '@/Components/Elements/Tags/TypeTag.vue'
import TextTooltip from '@/Components/Elements/TextTooltip.vue'

export default {
    name: 'TypeTagRow',

    components: {
        Tag,
        TypeTag,
        TextTooltip,
    },

    props: {
        types: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        visibleTags: 0,
    }),

    created() {
        this.containerClasses = 'flex gap-3 overflow-hidden'
    },

    mounted() {
        this.calculateVisibleTags()
        this.resizeObserver = new ResizeObserver(this.calculateVisibleTags)
        this.resizeObserver.observe(this.$refs.measureContainer)
    },

    watch: {
        types() {
            this.calculateVisibleTags()
        },
    },

    beforeUnmount() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect()
        }
    },

    computed: {
        hiddenTypesTooltipText() {
            return this.types
                .slice(this.visibleTags.length)
                .map((type) => type.name)
                .join(',<br> ')
        },
    },

    methods: {
        /**
         * Use the invisible container (measureContainer) to calculate how many
         * tags can be displayed in the visible container.
         */
        calculateVisibleTags() {
            this.$nextTick(() => {
                const container = this.$refs.measureContainer
                if (container) {
                    const containerWidth = container.clientWidth
                    let currentWidth = 0
                    let gapWidth = 12 // Add 12px for the gap (Tailwind gap-3)
                    let visibleTags = []

                    // Add the width of the tag that displays the overflowing tags
                    let extraTagWidth =
                        this.$refs.extraTag.$el.offsetWidth + gapWidth

                    const tagElements = container.querySelectorAll('.tag')

                    for (let i = 0; i < tagElements.length; i++) {
                        const tagWidth = tagElements[i].offsetWidth + gapWidth
                        if (
                            (i == tagElements.length - 1 &&
                                currentWidth + tagWidth > containerWidth) ||
                            (i < tagElements.length - 1 &&
                                currentWidth + tagWidth + extraTagWidth >
                                    containerWidth)
                        ) {
                            break
                        }

                        currentWidth += tagWidth
                        visibleTags.push(this.types[i])
                    }

                    this.visibleTags = visibleTags
                }
            })
        },
    },
}
</script>
